import { ErrorAlert, LoadingAlert } from '@/components';
import { Card } from '@/components/atoms';
import { useNews } from '@/components/providers';
import { logError } from '@/utils/logger';
import { NEWS } from '@/utils/strings';
import { FC } from 'react';
import NewsList from './NewsList';
interface AllNewsCardProps {
  className?: string;
}
const AllNewsCard: FC<AllNewsCardProps> = ({ className }) => {
  const { isLoading, error } = useNews();
  const renderBody = () => {
    if (isLoading) {
      return (
        <LoadingAlert
          title={NEWS.LOADING_TITLE}
          description={NEWS.LOADING_DESCRIPTION}
        />
      );
    }
    if (error) {
      logError('Error loading news', 'AllNewsCard', { error });
      return (
        <ErrorAlert
          title={NEWS.ERROR_LOADING_TITLE}
          description={NEWS.ERROR_LOADING_DESCRIPTION}
        />
      );
    }
    return <NewsList includeMetadata />;
  };
  return (
    <Card className={className}>
      <Card.Header title="All News" loading={isLoading} />
      <Card.Body>{renderBody()}</Card.Body>
    </Card>
  );
};
export default AllNewsCard;
